export function currencyPairFormDataToRequestData (formData, id) {
  return {
    id,
    fromCurrency: formData.fromCurrency,
    toCurrency: formData.toCurrency,
    buy: {
      rate: formData.buyRate,
      dayMargin: formData.buyDayMargin,
      dayMarginEnabled: formData.buyDayMarginEnabled,
      nightMargin: formData.buyNightMargin,
      nightMarginEnabled: formData.buyNightMarginEnabled,
      weekendMargin: formData.buyWeekendMargin,
      weekendMarginEnabled: formData.buyWeekendMarginEnabled,
      fee: formData.buyFee,
      enabled: formData.buyEnabled
    },
    sell: {
      rate: formData.sellRate,
      dayMargin: formData.sellDayMargin,
      dayMarginEnabled: formData.sellDayMarginEnabled,
      nightMargin: formData.sellNightMargin,
      nightMarginEnabled: formData.sellNightMarginEnabled,
      weekendMargin: formData.sellWeekendMargin,
      weekendMarginEnabled: formData.sellWeekendMarginEnabled,
      fee: formData.sellFee,
      enabled: formData.sellEnabled
    },
    useAutoRate: formData.useAutoRate
  }
}

export function currencyPairToFormData (currencyPair) {
  return {
    fromCurrency: currencyPair.fromCurrency,
    toCurrency: currencyPair.toCurrency,
    buyRate: currencyPair.buy.rate,
    buyDayMargin: currencyPair.buy.dayMargin,
    buyDayMarginEnabled: currencyPair.buy.dayMarginEnabled,
    buyNightMargin: currencyPair.buy.nightMargin,
    buyNightMarginEnabled: currencyPair.buy.nightMarginEnabled,
    buyWeekendMargin: currencyPair.buy.weekendMargin,
    buyWeekendMarginEnabled: currencyPair.buy.weekendMarginEnabled,
    buyFee: currencyPair.buy.fee,
    buyEnabled: currencyPair.buy.enabled,
    sellRate: currencyPair.sell.rate,
    sellDayMargin: currencyPair.sell.dayMargin,
    sellDayMarginEnabled: currencyPair.sell.dayMarginEnabled,
    sellNightMargin: currencyPair.sell.nightMargin,
    sellNightMarginEnabled: currencyPair.sell.nightMarginEnabled,
    sellWeekendMargin: currencyPair.sell.weekendMargin,
    sellWeekendMarginEnabled: currencyPair.sell.weekendMarginEnabled,
    sellFee: currencyPair.sell.fee,
    sellEnabled: currencyPair.sell.enabled,
    useAutoRate: currencyPair.useAutoRate
  }
}
